import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom"; // Import Navigate for redirection
import axiosInstance from "../../services/api/API";
import SidePanel from "../../SidePanel";
import "./CardLayout.scss";
import HeaderNavbar from "../../HeaderNavbar";

const CardLayout = () => {
  const location = useLocation();
  const [menuData, setMenuData] = useState([]);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const token = localStorage.getItem("authToken");

  const card_id = location?.state?.card_id || localStorage.getItem("card_id");

  const getPriviledges = useCallback(
    async (cardId) => {
      try {
        if (!token) {
          throw new Error("Token not found");
        }

        const response = await axiosInstance.post(
          "/getPrivileges",
          { card_id: cardId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status !== 200) {
          throw new Error("Failed to fetch privileges");
        }

        const data = response.data.data;
        setMenuData(data);
      } catch (error) {
        console.error("Error fetching privileges:", error.message);
      }
    },
    [token]
  );

  useEffect(() => {
    if (card_id) {
      localStorage.setItem("card_id", card_id);
      getPriviledges(card_id);
    }

    return () => {
      // Cleanup if needed
    };
  }, [card_id, getPriviledges]);

  const handleSidePanelToggle = () => {
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  // Check if the user is authenticated
  if (!token) {
    return <Navigate to="/" replace />; // Redirect to the login page if not authenticated
  }

  return (
    <div className={`layoutMainContainer ${isSidePanelOpen ? "sidepanel-open" : ""}`}>
      <div className={`sidepanel ${isSidePanelOpen ? "open" : ""}`}>
        <SidePanel card_id={card_id} menuData={menuData} />
      </div>
      <div className="header">
        <HeaderNavbar  menuData={menuData} />
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default CardLayout;
